import { useMemo } from "react";
import { evaluateProject } from "../../features/evaluate";

interface ProgressIndicatorProps {
  editorState?: any; // EditorViewState from store
}

export const ProgressIndicator = (props: ProgressIndicatorProps) => {
  const { editorState } = props;

  // Prüfe sowohl subTasks als auch subtasks (für Kompatibilität)
  const subTasks = editorState?.project?.subTasks || (editorState?.project as any)?.subtasks;
  const hasEval = editorState?.project?.eval !== undefined;
  const projectFinished = editorState?.data?.projectFinished === true;
  
  // Cache die Auswertung für eval-Projekte, um Performance zu verbessern
  // Muss immer aufgerufen werden (React Hooks Regel)
  const isTaskSolved = useMemo(() => {
    if (!editorState?.project || !hasEval || subTasks) {
      return false; // Nicht relevant für diese Projekte
    }
    // Prüfe ob editorCode vorhanden ist, bevor evaluateProject aufgerufen wird
    if (!editorState?.data?.editorCode) {
      return false; // Editor noch nicht geladen
    }
    try {
      return projectFinished || evaluateProject(editorState.project, editorState?.data?.projectProgress);
    } catch (error) {
      console.warn('ProgressIndicator: Error evaluating project', error);
      return false;
    }
  }, [projectFinished, hasEval, subTasks, editorState?.project, editorState?.data?.projectProgress, editorState?.data?.editorCode]);

  if (!editorState?.project) {
    return null;
  }
  
  // Für Projekte mit subTasks: Fortschritt basierend auf Anzahl der gelösten Aufgaben
  if (subTasks && Array.isArray(subTasks) && subTasks.length > 0) {
    const projectProgress = editorState?.data?.projectProgress || 0;
    const totalTasks = subTasks.length;
    const progressPercent = totalTasks > 0 
      ? Math.min(100, Math.round((projectProgress / totalTasks) * 100))
      : 0;

    return (
      <div className="progress-indicator">
        <span className="progress-text">Fortschritt:</span>
        <div className="progress-bar">
          <div className="progress-fill" style={{ width: `${progressPercent}%` }}></div>
        </div>
        <span className="progress-fraction">{projectProgress}/{totalTasks}</span>
      </div>
    );
  }
  
  // Für Projekte mit eval (ohne subTasks): Binärer Status
  if (hasEval && !subTasks) {
    return (
      <div className="progress-indicator">
        <span className="progress-text">
          {isTaskSolved ? "Aufgabe gelöst ✔️" : "Aufgabe noch nicht gelöst"}
        </span>
      </div>
    );
  }

  // Keine Anzeige wenn weder subTasks noch eval vorhanden
  return null;
};

export default ProgressIndicator;
